module.exports = __webpack_public_path__ + "img/passwords-w.4275cdad.svg";